export default "__VITE_ASSET__bkqeFc$o__"